if (!customElements.get("variant-selects")) {
  class t extends HTMLElement {
    constructor() {
      super(),
        (this.sticky = this.dataset.sticky),
        (this.updateUrl = "true" === this.dataset.updateUrl),
        (this.isDisabledFeature = this.dataset.isDisabled),
        this.addEventListener("change", this.onVariantChange),
        (this.other = Array.from(
          document.querySelectorAll("variant-selects")
        ).filter((t) => t != this)),
        (this.productWrapper = this.closest(".thb-product-detail")),
        this.productWrapper &&
          ((this.productSlider = this.productWrapper.querySelector(
            `#MediaGallery-${this.dataset.section}`
          )),
          (this.hideVariants =
            "true" === this.productSlider?.dataset.hideVariants));
    }
    connectedCallback() {
      this.updateUrl &&
        (this.updateOptions(),
        this.updateMasterId(),
        this.setDisabled(),
        this.setImageSet());
    }
    onVariantChange() {
      this.updateOptions(),
        this.updateMasterId(),
        this.toggleAddButton(!0, "", !1),
        this.updatePickupAvailability(),
        this.removeErrorMessage(),
        this.updateVariantText(),
        this.setDisabled(),
        this.currentVariant
          ? (this.updateMedia(),
            this.updateUrl && this.updateURL(),
            this.updateVariantInput(),
            this.renderProductInfo())
          : (this.toggleAddButton(!0, "", !0), this.setUnavailable()),
        this.updateOther(),
        dispatchCustomEvent("product:variant-change", {
          variant: this.currentVariant,
          sectionId: this.dataset.section,
        });
    }
    updateOptions() {
      (this.fieldsets = Array.from(this.querySelectorAll("fieldset"))),
        (this.options = []),
        (this.option_keys = []),
        this.fieldsets.forEach((t, e) => {
          t.querySelector("select")
            ? (this.options.push(t.querySelector("select").value),
              this.option_keys.push(t.querySelector("select").name))
            : t.querySelectorAll("input").length &&
              (this.options.push(t.querySelector("input:checked").value),
              this.option_keys.push(t.querySelector("input").name));
        }),
        (this.dataset.options = this.options);
    }
    updateVariantText() {
      let t = Array.from(this.querySelectorAll("fieldset"));
      t.forEach((t, e) => {
        let i = t.querySelector(".form__label__value");
        i && (i.innerHTML = this.options[e]);
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find(
        (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
      );
    }
    updateOther() {
      if ("false" !== this.dataset.updateUrl && this.other.length) {
        let t = Array.from(this.other[0].querySelectorAll("fieldset"));
        this.options.forEach((e, i) => {
          t[i].querySelector("select")
            ? (t[i].querySelector("select").value = e)
            : t[i].querySelectorAll("input").length &&
              (t[i].querySelector(`input[value="${e}"]`).checked = !0);
        }),
          this.other[0].updateOptions(),
          this.other[0].updateMasterId(),
          this.other[0].updateVariantText(),
          this.other[0].setDisabled();
      }
    }
    updateMedia() {
      if (
        !this.currentVariant ||
        !this.currentVariant.featured_media ||
        !this.productSlider
      )
        return;
      let t = `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        e = this.productSlider.querySelector(`[data-media-id="${t}"]`);
      this.productSlider.querySelectorAll("[data-media-id]").forEach((t) => {
        t.classList.remove("is-active");
      }),
        this.setImageSetMedia(),
        e.classList.add("is-active"),
        e.parentElement.prepend(e),
        this.sticky ||
          window.setTimeout(() => {
            if (window.innerWidth > 1068) {
              let t =
                  e.parentElement.offsetTop -
                  parseInt(
                    getComputedStyle(document.documentElement).getPropertyValue(
                      "--header-height"
                    )
                  ),
                i = { left: 0, behavior: "instant" };
              t > 0 && (i.top = t), window.scrollTo(i);
            }
            e.parentElement.scrollTo({ left: 0, behavior: "instant" });
          });
    }
    updateURL() {
      this.currentVariant &&
        "false" !== this.dataset.updateUrl &&
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }
    updateShareUrl() {
      let t = document.getElementById(`Share-${this.dataset.section}`);
      t &&
        t.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }
    updateVariantInput() {
      let t = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      );
      t.forEach((t) => {
        let e = t.querySelector('input[name="id"]');
        (e.value = this.currentVariant.id),
          e.dispatchEvent(new Event("change", { bubbles: !0 }));
      });
    }
    updatePickupAvailability() {
      let t = document.querySelector(".pickup-availability-wrapper");
      t &&
        (this.currentVariant && this.currentVariant.available
          ? t.fetchAvailability(this.currentVariant.id)
          : (t.removeAttribute("available"), (t.innerHTML = "")));
    }
    removeErrorMessage() {
      let t = this.closest("section");
      if (!t) return;
      let e = t.querySelector("product-form");
      e && e.handleErrorMessage();
    }
    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
      ];
    }
    renderProductInfo() {
      let t = this.getSectionsToRender();
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((t) => t.text())
        .then((e) => {
          let i = new DOMParser().parseFromString(e, "text/html");
          t.forEach((t) => {
            let e = document.getElementById(t),
              s = i.getElementById(t);
            s && e && (e.innerHTML = s.innerHTML);
            let r = document.getElementById(t),
              a = document.getElementById(t + "--sticky");
            r && r.classList.remove("visibility-hidden"),
              a && a.classList.remove("visibility-hidden");
          }),
            this.toggleAddButton(
              !this.currentVariant.available,
              window.theme.variantStrings.soldOut
            );
        });
    }
    toggleAddButton(t = !0, e = !1, i = !0) {
      let s = document.getElementById(`product-form-${this.dataset.section}`);
      if (!s) return;
      let r = s.closest(".product-form").getAttribute("template"),
        a = document.querySelectorAll(".single-add-to-cart-button");
      if (
        a &&
        (a.forEach((i) => {
          let s = i.querySelector(".single-add-to-cart-button--text");
          s &&
            (t
              ? (i.setAttribute("disabled", "disabled"),
                e && (s.textContent = e))
              : (i.removeAttribute("disabled"),
                i.classList.remove("loading"),
                r?.includes("pre-order")
                  ? (s.textContent = window.theme.variantStrings.preOrder)
                  : (s.textContent = window.theme.variantStrings.addToCart)));
        }),
        !i)
      )
        return;
    }
    setUnavailable() {
      let t = document.querySelectorAll(".single-add-to-cart-button"),
        e = document.getElementById(`price-${this.dataset.section}`),
        i = document.getElementById(`price-${this.dataset.section}--sticky`);
      t.forEach((t) => {
        let e = t.querySelector(".single-add-to-cart-button--text");
        t &&
          ((e.textContent = window.theme.variantStrings.unavailable),
          t.classList.add("sold-out"));
      }),
        e && e.classList.add("visibility-hidden"),
        i && i.classList.add("visibility-hidden");
    }
    setDisabled() {
      if ("true" != this.isDisabledFeature) return;
      let t = this.getVariantData();
      if (t) {
        let e = !1;
        if (this.currentVariant)
          e = this.currentVariant.options.map((t, e) => ({
            value: t,
            index: `option${e + 1}`,
          }));
        else {
          let i = t.find((t) => t.option1 === this.options[0]);
          if (!i) return;
          e = [
            { value: this.options[0], index: "option1" },
            { value: i.option2, index: "option2" },
          ];
        }
        let s = this.createAvailableOptionsTree(t, e);
        this.fieldsets.forEach((t, e) => {
          let i = Object.values(s)[e];
          i &&
            (t.querySelector("select")
              ? i.forEach((e, i) => {
                  e.isUnavailable
                    ? (t.querySelector(
                        "option[value=" + JSON.stringify(e.value) + "]"
                      ).disabled = !0)
                    : (t.querySelector(
                        "option[value=" + JSON.stringify(e.value) + "]"
                      ).disabled = !1);
                })
              : t.querySelectorAll("input").length &&
                t.querySelectorAll("input").forEach((t, e) => {
                  t.classList.toggle("is-disabled", i[e].isUnavailable);
                }));
        });
      }
      this.updateCartHolderVisibility();
      return !0;
    }

    updateCartHolderVisibility() {
      const holderEl = document.querySelector(".add_to_cart_holder");
      holderEl.classList[this.currentVariant.available ? "remove" : "add"](
        "hide-cart-holder"
      );
    }

    getImageSetName(t) {
      return t
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }
    setImageSet() {
      if (!this.productSlider) return;
      let t = this.productSlider.querySelector("[data-set-name]");
      t &&
        ((this.imageSetName = t.dataset.setName),
        (this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]'
        ).dataset.index),
        this.setImageSetMedia());
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) return;
      let t = this.getImageSetName(this.currentVariant[this.imageSetIndex]),
        e = this.imageSetName + "_" + t,
        i = this.productSlider.querySelectorAll(
          `[data-set-name="${this.imageSetName}"]`
        );
      this.hideVariants
        ? i.forEach((t) => {
            t.classList.toggle("is-active", t.dataset.group === e);
          })
        : Array.from(i)
            .filter(function (t) {
              return t.dataset.group === e;
            })
            .forEach((t) => {
              t.parentElement.prepend(t);
            }),
        setTimeout(() => {
          this.productSlider
            .querySelector("product-slider")
            .onPaginationResize();
        }, 100);
    }
    createAvailableOptionsTree(t, e) {
      return t.reduce(
        (t, i) => (
          Object.keys(t).forEach((s) => {
            if (null === i[s]) return;
            let r = t[s].find((t) => t.value === i[s]);
            void 0 === r &&
              ((r = { value: i[s], isUnavailable: !0 }), t[s].push(r));
            let a = e.reduce(
              (t, { value: e, index: s }) => (i[s] === e ? t + 1 : t),
              0
            );
            a >= e.length - 1 &&
              (r.isUnavailable =
                (!r.isUnavailable || !i.available) && r.isUnavailable),
              (!this.currentVariant || !this.currentVariant.available) &&
                e.find((t) => t.value === r.value && s === t.index) &&
                (r.isUnavailable = !0),
              "option1" === s &&
                (r.isUnavailable =
                  (!r.isUnavailable || !i.available) && r.isUnavailable);
          }),
          t
        ),
        { option1: [], option2: [], option3: [] }
      );
    }
    getVariantData() {
      return (
        (this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          )),
        this.variantData
      );
    }
  }
  customElements.define("variant-selects", t);
  class e extends t {
    constructor() {
      super();
    }
    updateOptions() {
      let t = Array.from(this.querySelectorAll("fieldset"));
      this.options = t.map(
        (t) =>
          Array.from(t.querySelectorAll("input")).find((t) => t.checked).value
      );
    }
  }
  customElements.define("variant-radios", e);
}
if (!customElements.get("product-slider")) {
  class i extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.pagination = this.parentElement.querySelector(
        ".product-images-buttons"
      )),
        (this.sliderItems = this.querySelectorAll('[id^="Slide-"]'));
      new MutationObserver(() => {
        this.setupProductGallery();
      }).observe(this, {
        attributes: !0,
        attributeFilter: ["class"],
        childList: !0,
        characterData: !1,
      }),
        this.setupProductGallery(),
        this.pagination &&
          (this.setupPagination(),
          (this.resizeObserver = new ResizeObserver((t) =>
            this.onPaginationResize()
          )),
          this.resizeObserver.observe(this),
          this.addEventListener("scroll", this.updatePagination.bind(this)));
    }
    setupProductGallery() {
      this.querySelectorAll(".product-single__media-zoom").length &&
        this.setEventListeners();
    }
    buildItems(t) {
      return t.map((t) => {
        let e = t.querySelector(".product-single__media-zoom");
        return {
          src: e.getAttribute("href"),
          msrc: e.dataset.msrc,
          w: e.dataset.w,
          h: e.dataset.h,
          title: e.getAttribute("title"),
        };
      });
    }
    setEventListeners() {
      let t = Array.from(
          this.querySelectorAll(".product-images__slide--image")
        ).filter((t) => t.clientWidth > 0),
        e = this.buildItems(t),
        i = this.dataset.captions,
        s = document.querySelectorAll(".pswp")[0],
        r = {
          maxSpreadZoom: 2,
          loop: !1,
          allowPanToNext: !1,
          closeOnScroll: !1,
          showHideOpacity: !1,
          arrowKeys: !0,
          history: !1,
          captionEl: i,
          fullscreenEl: !1,
          zoomEl: !1,
          shareEl: !1,
          counterEl: !0,
          arrowEl: !0,
          preloaderEl: !0,
        },
        a = function (e, i, s, r, a) {
          let n = i.closest(".product-images__slide"),
            o = t.indexOf(n);
          if (
            ((s.index = parseInt(o, 10)),
            (s.getThumbBoundsFn = () => {
              let t = i.closest(".product-single__media"),
                e = window.scrollY || document.documentElement.scrollTop,
                s = t.getBoundingClientRect();
              return { x: s.left, y: s.top + e, w: s.width };
            }),
            "undefined" != typeof PhotoSwipe)
          ) {
            let l = new PhotoSwipe(r, PhotoSwipeUI_Default, a, s);
            l.listen("firstUpdate", () => {
              l.listen("parseVerticalMargin", function (t) {
                t.vGap = { top: 50, bottom: 50 };
              });
            }),
              l.init();
          }
          e.preventDefault();
        };
      this.querySelectorAll(".product-single__media-zoom").forEach(function (
        t
      ) {
        let i = t.closest(".product-single__media"),
          n = t.cloneNode(!0);
        i.append(n),
          t.remove(),
          n.addEventListener("click", (t) => a(t, n, r, s, e));
      });
    }
    setupPagination() {
      (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (t) => t.clientWidth > 0
      )),
        this.sliderItemsToShow.length < 2 ||
          ((this.sliderItemOffset =
            this.sliderItemsToShow[1].offsetLeft -
            this.sliderItemsToShow[0].offsetLeft),
          (this.currentPageElement = this.pagination.querySelector(
            ".slider-counter--current"
          )),
          (this.pageTotalElement = this.pagination.querySelector(
            ".slider-counter--total"
          )),
          (this.prevButton = this.pagination.querySelector(
            'button[name="previous"]'
          )),
          (this.nextButton = this.pagination.querySelector(
            'button[name="next"]'
          )),
          this.prevButton.addEventListener(
            "click",
            this.onPaginationButtonClick.bind(this)
          ),
          this.nextButton.addEventListener(
            "click",
            this.onPaginationButtonClick.bind(this)
          ),
          this.updatePagination());
    }
    onPaginationResize() {
      (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (t) => t.clientWidth > 0
      )),
        this.sliderItemsToShow.length < 2 ||
          ((this.sliderItemOffset =
            this.sliderItemsToShow[1].offsetLeft -
            this.sliderItemsToShow[0].offsetLeft),
          this.updatePagination());
    }
    onPaginationButtonClick(t) {
      t.preventDefault(),
        (this.slideScrollPosition =
          "next" === t.currentTarget.name
            ? this.scrollLeft + 1 * this.sliderItemOffset
            : this.scrollLeft - 1 * this.sliderItemOffset),
        this.scrollTo({ left: this.slideScrollPosition });
    }
    updatePagination() {
      if (!this.nextButton) return;
      let t = this.currentPage;
      (this.currentPage =
        Math.round(this.scrollLeft / this.sliderItemOffset) + 1),
        this.currentPageElement &&
          (this.currentPageElement.textContent = this.currentPage),
        this.pageTotalElement &&
          (this.pageTotalElement.textContent = this.sliderItemsToShow.length),
        this.currentPage != t &&
          this.dispatchEvent(
            new CustomEvent("slideChanged", {
              detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1],
              },
            })
          ),
        this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.scrollLeft
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled");
    }
    isSlideVisible(t, e = 0) {
      let i = this.clientWidth + this.scrollLeft - e;
      return (
        t.offsetLeft + t.clientWidth <= i && t.offsetLeft >= this.scrollLeft
      );
    }
  }
  customElements.define("product-slider", i);
}
if (
  (customElements.get("product-form") ||
    customElements.define(
      "product-form",
      class t extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          (this.sticky = this.dataset.sticky),
            (this.form = document.getElementById(
              `product-form-${this.dataset.section}`
            )),
            (this.form.querySelector("[name=id]").disabled = !1),
            this.sticky ||
              this.form.addEventListener(
                "submit",
                this.onSubmitHandler.bind(this)
              ),
            (this.cartNotification =
              document.querySelector("cart-notification")),
            (this.body = document.body),
            (this.hideErrors = "true" === this.dataset.hideErrors);
        }
        onSubmitHandler(t) {
          if ((t.preventDefault(), !this.form.reportValidity())) return;
          let e = document.querySelectorAll(".single-add-to-cart-button");
          e.forEach((t) => {
            t.classList.contains("loading") ||
              (t.setAttribute("aria-disabled", !0), t.classList.add("loading"));
          }),
            this.handleErrorMessage();
          let i = {
              method: "POST",
              headers: {
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/javascript",
              },
            },
            s = new FormData(this.form);
          s.append(
            "sections",
            this.getSectionsToRender().map((t) => t.section)
          ),
            s.append("sections_url", window.location.pathname),
            (i.body = s),
            fetch(`${theme.routes.cart_add_url}`, i)
              .then((t) => t.json())
              .then((t) => {
                if (t.status) {
                  dispatchCustomEvent("product:variant-error", {
                    source: "product-form",
                    productVariantId: s.get("id"),
                    errors: t.description,
                    message: t.message,
                  }),
                    this.handleErrorMessage(t.description);
                  return;
                }
                this.renderContents(t),
                  dispatchCustomEvent("cart:item-added", {
                    product: t.hasOwnProperty("items") ? t.items[0] : t,
                  });
              })
              .catch((t) => {
                console.error(t);
              })
              .finally(() => {
                e.forEach((t) => {
                  t.classList.remove("loading"),
                    t.removeAttribute("aria-disabled");
                });
              });
        }
        getSectionsToRender() {
          return [
            { id: "Cart", section: "main-cart", selector: ".thb-cart-form" },
            {
              id: "Cart-Drawer",
              section: "cart-drawer",
              selector: ".side-panel-content",
            },
            {
              id: "Cart-Drawer",
              section: "cart-drawer",
              selector: ".side-panel-footer",
            },
            {
              id: "cart-drawer-toggle",
              section: "cart-bubble",
              selector: ".thb-item-count",
            },
          ];
        }
        renderContents(t) {
          this.getSectionsToRender().forEach((e) => {
            if (!document.getElementById(e.id)) return;
            let i =
              document.getElementById(e.id).querySelector(e.selector) ||
              document.getElementById(e.id);
            (i.innerHTML = this.getSectionInnerHTML(
              t.sections[e.section],
              e.selector
            )),
              "undefined" != typeof CartDrawer && new CartDrawer(),
              "undefined" != typeof Cart && new Cart().renderContents(t);
          });
          let e = document.getElementById("Product-Drawer");
          e && e.contains(this)
            ? (e
                .querySelector(".product-quick-images--container")
                .classList.remove("active"),
              document.body.classList.remove("open-quick-view"),
              window.innerWidth < 1069
                ? (e.classList.remove("active"),
                  document.getElementById("Cart-Drawer") &&
                    (document
                      .getElementById("Cart-Drawer")
                      .classList.add("active"),
                    document.body.classList.add("open-cart"),
                    document
                      .getElementById("Cart-Drawer")
                      .querySelector(".product-recommendations--full")
                      .classList.add("active"),
                    dispatchCustomEvent("cart-drawer:open")))
                : e
                    .querySelector(".product-quick-images--container")
                    .addEventListener("transitionend", function () {
                      e.classList.remove("active"),
                        document.getElementById("Cart-Drawer") &&
                          (document
                            .getElementById("Cart-Drawer")
                            .classList.add("active"),
                          document.body.classList.add("open-cart"),
                          document
                            .getElementById("Cart-Drawer")
                            .querySelector(".product-recommendations--full")
                            .classList.add("active"),
                          dispatchCustomEvent("cart-drawer:open"));
                    }),
              document.getElementById("Cart-Drawer") ||
                document.body.classList.remove("open-cc"))
            : document.getElementById("Cart-Drawer") &&
              (document.body.classList.add("open-cc"),
              document.body.classList.add("open-cart"),
              document.getElementById("Cart-Drawer").classList.add("active"),
              dispatchCustomEvent("cart-drawer:open"));
        }
        getSectionInnerHTML(t, e = ".shopify-section") {
          return new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(e).innerHTML;
        }
        handleErrorMessage(t = !1) {
          !this.hideErrors &&
            ((this.errorMessageWrapper =
              this.errorMessageWrapper ||
              this.querySelector(".product-form__error-message-wrapper")),
            (this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t));
        }
      }
    ),
  !customElements.get("product-add-to-cart-sticky"))
) {
  class s extends HTMLElement {
    constructor() {
      super(),
        (this.animations_enabled =
          document.body.classList.contains("animations-true") &&
          "undefined" != typeof gsap);
    }
    connectedCallback() {
      this.setupObservers(), this.setupToggle();
    }
    setupToggle() {
      let t = this.querySelector(".product-add-to-cart-sticky--inner"),
        e = this.querySelector(".product-add-to-cart-sticky--content");
      if (this.animations_enabled) {
        let i = gsap.timeline({
          reversed: !0,
          paused: !0,
          onStart() {
            t.classList.add("sticky-open");
          },
          onReverseComplete() {
            t.classList.remove("sticky-open");
          },
        });
        i
          .set(e, { display: "block", height: "auto" }, "start")
          .from(e, { height: 0, duration: 0.25 }, "start+=0.001"),
          t.addEventListener("click", function () {
            return i.reversed() ? i.play() : i.reverse(), !1;
          });
      } else
        t.addEventListener("click", function () {
          return e.classList.toggle("active"), !1;
        });
    }
    setupObservers() {
      let t = this,
        e = new IntersectionObserver(
          function (e) {
            e.forEach((e) => {
              if (
                (e.target === s &&
                  (e.intersectionRatio > 0
                    ? t.classList.remove("sticky--visible")
                    : 0 == e.intersectionRatio &&
                      t.formPassed &&
                      t.classList.add("sticky--visible")),
                e.target === i)
              ) {
                let r = i.getBoundingClientRect();
                0 === e.intersectionRatio && window.scrollY > r.top + r.height
                  ? ((t.formPassed = !0), t.classList.add("sticky--visible"))
                  : 1 === e.intersectionRatio &&
                    ((t.formPassed = !1),
                    t.classList.remove("sticky--visible"));
              }
            });
          },
          { threshold: [0, 1] }
        ),
        i = document.getElementById(`product-form-${this.dataset.section}`),
        s = document.getElementById("footer");
      (t.formPassed = !1), e.observe(i), e.observe(s);
    }
  }
  customElements.define("product-add-to-cart-sticky", s);
}
"undefined" != typeof addIdToRecentlyViewed && addIdToRecentlyViewed();
2;
